/**
 * Semantic colour tokens. Components only ever reference these names (as CSS variables on web,
 * StyleSheet values on native), so a festival theme can recolour the whole app.
 */
export interface Palette {
  bg: string;
  bgGlow: string;
  surface: string;
  surfaceRaised: string;
  surfaceMuted: string;
  border: string;
  text: string;
  textMuted: string;
  textFaint: string;
  felt: string;
  feltDeep: string;
  feltLight: string;
  feltLine: string;
  rim: string;
  rimHighlight: string;
  accent: string;
  accentStrong: string;
  accentText: string;
  accentSoft: string;
  teamA: string;
  teamASoft: string;
  teamB: string;
  teamBSoft: string;
  cardFace: string;
  cardEdge: string;
  cardInk: string;
  cardRed: string;
  cardBlue: string;
  cardGreen: string;
  cardBack: string;
  cardBackPattern: string;
  danger: string;
  success: string;
  warning: string;
  focus: string;
}

export type PaletteToken = keyof Palette;

/** "Royal Indian card room": emerald felt, brass accents, ivory cards, jewel-tone teams. */
export const ROYAL_PALETTE: Palette = {
  bg: '#08110e',
  bgGlow: '#123228',
  surface: '#101d18',
  surfaceRaised: '#172a23',
  surfaceMuted: '#0d1814',
  border: 'rgba(232, 214, 170, 0.14)',
  text: '#f7f0e1',
  textMuted: '#c2b9a3',
  textFaint: '#8d8674',
  felt: '#0f5a42',
  feltDeep: '#083a2b',
  feltLight: '#1b7a5a',
  feltLine: 'rgba(240, 220, 160, 0.16)',
  rim: '#3b2414',
  rimHighlight: '#b8893b',
  accent: '#e6b450',
  accentStrong: '#f5cd72',
  accentText: '#1f1505',
  accentSoft: 'rgba(230, 180, 80, 0.16)',
  teamA: '#5fdcae',
  teamASoft: 'rgba(95, 220, 174, 0.18)',
  teamB: '#b3a6ff',
  teamBSoft: 'rgba(179, 166, 255, 0.18)',
  cardFace: '#fdf9f0',
  cardEdge: '#e4dccb',
  cardInk: '#1c1c22',
  cardRed: '#c62f2f',
  cardBlue: '#1f5fbf',
  cardGreen: '#1d7a3e',
  cardBack: '#7a1d2c',
  cardBackPattern: '#e6b450',
  danger: '#f26b62',
  success: '#5fdcae',
  warning: '#f3bd4f',
  focus: '#ffd77a',
};

export function cssVarName(token: PaletteToken): string {
  return `--c-${token.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`)}`;
}
